module.exports = __webpack_public_path__ + "static/media/logo-internal.aa929bdc.png";